import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/trailer/logo-bincentive.png';

const _withScopeId = n => (_pushScopeId("data-v-78a8a0d5"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "trailer-container"
};

const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"wrapper\" data-v-78a8a0d5><div class=\"logo-wrapper\" data-v-78a8a0d5><div class=\"logo\" data-v-78a8a0d5></div><span class=\"coming-soon\" data-v-78a8a0d5>Coming Soon</span></div><div class=\"bincentive\" data-v-78a8a0d5><img src=\"" + _imports_0 + "\" alt=\"bincentive\" data-v-78a8a0d5></div></div>", 1);

const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}